import Container from "./../ui/container";
import Heading from "./../ui/heading";
import { SERVICES } from "./../constant/services";
import { ChevronRight } from "lucide-react";
import React, { useEffect } from "react";
import "./service-details.css"
import ContactComponent from "./../SharedComponent/ContactComponent";
import { Link } from "react-router-dom";

// Remove TypeScript interface and use plain JS destructuring
const ServiceDetails = ({
  title,
  slug,
  img,
  description,
  includes,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="service-details-section">
      <Container>
        <div className="service-details-grid">
          <div className="service-details-sidebar">
            {SERVICES.map((item) => (
              <Link
                key={item.slug}
                to={`/services/${item.slug}`}
                className={`service-details-link${slug === item.slug ? " service-details-link-active" : ""}`}
              >
                <span className="service-details-link-title">
                  {item.title}
                </span>
                <ChevronRight className="service-details-link-icon" />
              </Link>
            ))}

            <ContactComponent />
          </div>
          <div className="service-details-content">
            <img
              src={img}
              className="service-details-image"
              alt={title}
            />

            <div className="service-details-info">
              <Heading variant="H2" style={{ color: "#0076fe" }}>
                {title}
              </Heading>
              <p className="service-details-description">{description}</p>
              <ul className="service-details-includes">
                {includes.map((item) => (
                  <li key={item} className="service-details-include-item">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ServiceDetails;
